// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-carousel {
  height: 460px;
}
.header-carousel .slide-item {
  height: 100%;
  background-size: cover;
  background-position: center;
}
.header-carousel .swiper-lazy-preloader {
  top: 15%;
}
.header-carousel .slide-info {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  z-index: 2;
}
.header-carousel .slide-info .mat-mdc-card {
  text-align: center;
  min-width: 450px;
  transition: 0.4s;
  margin: 0 16px;
  align-items: center;
}
.header-carousel .slide-info .mat-mdc-card .slide-title {
  font-size: 32px;
  line-height: 32px;
  margin-bottom: 16px;
  text-transform: uppercase;
}
.header-carousel .slide-info .mat-mdc-card .location {
  font-size: 18px;
  font-style: italic;
  margin-bottom: 24px;
  font-weight: 500;
}
.header-carousel .slide-info .mat-mdc-card .price {
  font-size: 24px;
  min-width: 200px;
  padding: 4px 8px;
  height: auto;
}
.header-carousel.offset-bottom {
  height: 540px;
}
.header-carousel.offset-bottom .slide-info {
  padding-bottom: 80px;
}
.header-carousel.fullscreen {
  height: calc(100vh - (36px + 72px)) !important;
}
.header-carousel.fullscreen.toolbar-2 {
  height: calc(100vh - 202px) !important;
}

@media screen and (max-width: 599px) {
  .header-carousel {
    height: 340px;
  }
  .header-carousel.offset-bottom {
    height: 420px;
  }
  .header-carousel .slide-info .mat-mdc-card {
    min-width: 240px;
  }
  .header-carousel .slide-info .mat-mdc-card .slide-title {
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 16px;
  }
  .header-carousel .slide-info .mat-mdc-card .location {
    font-size: 14px;
    margin-bottom: 19px;
    align-items: start !important;
  }
  .header-carousel .slide-info .mat-mdc-card .price {
    font-size: 14px;
    min-width: 120px;
    padding: unset;
  }
}
@media screen and (min-width: 600px) and (max-width: 959px) {
  .header-carousel {
    height: 380px;
  }
  .header-carousel.offset-bottom {
    height: 460px;
  }
  .header-carousel .slide-info .mat-mdc-card {
    min-width: 400px;
  }
  .header-carousel .slide-info .mat-mdc-card .slide-title {
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 16px;
  }
  .header-carousel .slide-info .mat-mdc-card .location {
    font-size: 16px;
    margin-bottom: 24px;
  }
  .header-carousel .slide-info .mat-mdc-card .price {
    font-size: 20px;
    min-width: 160px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/header-carousel/header-carousel.component.scss","webpack://./src/app/theme/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACI,aCIqB;ADLzB;AAEI;EACI,YAAA;EACA,sBAAA;EACA,2BAAA;AAAR;AAEI;EACI,QAAA;AAAR;AAEI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;AAAR;AACQ;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACZ;AAAY;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;AAEhB;AAAY;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAEhB;AAAY;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAEhB;AAEI;EACI,aAAA;AAAR;AACQ;EACI,oBCtCwB;ADuCpC;AAEI;EACI,8CAAA;AAAR;AACQ;EACI,sCAAA;AACZ;;AAKA;EACI;IACI,aAAA;EAFN;EAGM;IACI,aAAA;EADV;EAIU;IACI,gBAAA;EAFd;EAGc;IACI,eAAA;IACA,iBAAA;IACA,mBAAA;EADlB;EAGc;IACI,eAAA;IACA,mBAAA;IACA,6BAAA;EADlB;EAGc;IACI,eAAA;IACA,gBAAA;IACA,cAAA;EADlB;AACF;AAQA;EACI;IACI,aAAA;EANN;EAOM;IACI,aAAA;EALV;EAQU;IACI,gBAAA;EANd;EAOc;IACI,eAAA;IACA,iBAAA;IACA,mBAAA;EALlB;EAOc;IACI,eAAA;IACA,mBAAA;EALlB;EAOc;IACI,eAAA;IACA,gBAAA;EALlB;AACF","sourcesContent":["@import \"../../theme/styles/variables\";\r\n\r\n.header-carousel{ \r\n    height: $header-carousel-height;\r\n    .slide-item{\r\n        height: 100%;\r\n        background-size: cover;\r\n        background-position: center;      \r\n    }\r\n    .swiper-lazy-preloader{\r\n        top: 15%;\r\n    }\r\n    .slide-info{\r\n        position: absolute;\r\n        height: 100%;\r\n        width: 100%;\r\n        top: 0;    \r\n        z-index: 2;\r\n        .mat-mdc-card{\r\n            text-align: center;\r\n            min-width: 450px;           \r\n            transition: 0.4s;\r\n            margin: 0 16px; \r\n            align-items: center;           \r\n            .slide-title{   \r\n                font-size: 32px;\r\n                line-height: 32px;\r\n                margin-bottom: 16px;\r\n                text-transform: uppercase;\r\n            }\r\n            .location{\r\n                font-size: 18px;\r\n                font-style: italic;\r\n                margin-bottom: 24px;\r\n                font-weight: 500;\r\n            }\r\n            .price{\r\n                font-size: 24px;\r\n                min-width: 200px;\r\n                padding: 4px 8px;\r\n                height: auto;\r\n            }\r\n        }\r\n    }\r\n    &.offset-bottom{\r\n        height: $header-carousel-height + $main-content-header-offset-to-top;        \r\n        .slide-info{\r\n            padding-bottom: $main-content-header-offset-to-top;\r\n        }\r\n    }\r\n    &.fullscreen{\r\n        height: calc(100vh - (#{$top-toolbar-height} + #{$main-toolbar-height})) !important;\r\n        &.toolbar-2{\r\n            height: calc(100vh - 202px) !important; \r\n        }\r\n    }\r\n}\r\n\r\n// xs\r\n@media screen and (max-width: 599px) {\r\n    .header-carousel {  \r\n        height: $header-carousel-height - 120px;\r\n        &.offset-bottom{\r\n            height: $header-carousel-height + $main-content-header-offset-to-top - 120px;\r\n        } \r\n        .slide-info{ \r\n            .mat-mdc-card{\r\n                min-width: 240px;\r\n                .slide-title{   \r\n                    font-size: 20px;\r\n                    line-height: 20px;\r\n                    margin-bottom: 16px;\r\n                }\r\n                .location{\r\n                    font-size: 14px;\r\n                    margin-bottom: 19px;\r\n                    align-items: start !important;\r\n                }\r\n                .price{\r\n                    font-size: 14px;\r\n                    min-width: 120px;\r\n                    padding: unset;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// sm\r\n@media screen and (min-width: 600px) and (max-width: 959px) {  \r\n    .header-carousel {  \r\n        height: $header-carousel-height - 80px;\r\n        &.offset-bottom{\r\n            height: $header-carousel-height + $main-content-header-offset-to-top - 80px;\r\n        }        \r\n        .slide-info{ \r\n            .mat-mdc-card{\r\n                min-width: 400px;\r\n                .slide-title{   \r\n                    font-size: 24px;\r\n                    line-height: 24px;\r\n                    margin-bottom: 16px;\r\n                }\r\n                .location{\r\n                    font-size: 16px;\r\n                    margin-bottom: 24px;\r\n                }\r\n                .price{\r\n                    font-size: 20px;\r\n                    min-width: 160px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","$font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n$theme-max-width: 1300px;\r\n$top-toolbar-height: 36px;\r\n$main-toolbar-height: 72px;\r\n$user-menu-width: 220px;\r\n$header-image-min-height: 320px;\r\n$header-video-min-height: 360px;\r\n$header-carousel-height: 460px;\r\n$header-map-height: 550px;\r\n$main-content-header-offset-to-top: 80px;\r\n\r\n$main-sidenav-width: 265px;\r\n$search-sidenav-width: 288px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
